/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState, useContext } from "react"
import { changeLocale } from "gatsby-plugin-intl"

import Helmet from "react-helmet"
import Header from "./header"
import Footer from "./footer"
import Toast from "./toast"
import Alert from "./alert"

import { Context } from "../context/Context"

const Layout = ({ name, children }) => {

  const [currentLang, setCurrentLang] = useState('')

  const { toast } = useContext(Context)

  const getRedirectLanguage = () => {
    if (typeof navigator === `undefined`) {
      return "en";
    }

    const lang = navigator && navigator.language && navigator.language.split("-")[0];
    if (!lang) return "it";
    return lang
  };


  useEffect(() => {

    let lang = localStorage.getItem('gatsby-intl-language') || getRedirectLanguage()
    // if (lang === 'en') lang = 'en-GB'
    if (currentLang !== lang) {
      setCurrentLang(lang)
      changeLocale(lang)
    } else return

    const iubendaExistingCookieBanner = [...document.querySelectorAll('.iubenda-cs-container'), ...document.querySelectorAll('#iubenda-cs-banner')]
    for (const el of iubendaExistingCookieBanner) {
      el.parentNode.removeChild(el);
    }

    const iubendaExistingScript = document.getElementById('iubenda-script')
    if (iubendaExistingScript) iubendaExistingScript.outerHTML = ''

    const _iub = _iub || [];

    const iubendaCb = {
      onPreferenceExpressedOrNotNeeded: function (preference) {
        dataLayer.push({ // eslint-disable-line
          iubenda_ccpa_opted_out: _iub.cs.api.isCcpaOptedOut()
        });
        if (!preference) {
          dataLayer.push({ // eslint-disable-line
            event: "iubenda_preference_not_needed"
          });
        } else {
          if (preference.consent === true) {
            dataLayer.push({ // eslint-disable-line
              event: "iubenda_consent_given"
            });
          } else if (preference.consent === false) {
            dataLayer.push({ // eslint-disable-line
              event: "iubenda_consent_rejected"
            });
          } else if (preference.purposes) {
            for (var purposeId in preference.purposes) {
              if (preference.purposes[purposeId]) {
                dataLayer.push({ // eslint-disable-line
                  event: "iubenda_consent_given_purpose_" + purposeId
                });
              }
            }
          }
        }
      }
    }

    _iub.csConfiguration = { "invalidateConsentWithoutLog": true, "consentOnContinuedBrowsing": false, "perPurposeConsent": true, "whitelabel": false, "lang": lang, "siteId": 2442925, "floatingPreferencesButtonDisplay": "bottom-right", "cookiePolicyId": 29997634, "banner": { "closeButtonDisplay": false, "acceptButtonDisplay": true, "customizeButtonDisplay": true, "acceptButtonColor": "#004b93", "acceptButtonCaptionColor": "white", "customizeButtonColor": "#212121", "customizeButtonCaptionColor": "white", "rejectButtonDisplay": true, "rejectButtonColor": "#004b93", "rejectButtonCaptionColor": "white", "listPurposes": true, "explicitWithdrawal": true, "position": "float-bottom-right", "textColor": "#7b8390", "backgroundColor": "#ffffff" }, callback: iubendaCb };
    window._iub = _iub


    var scriptTag = document.createElement('script');
    scriptTag.id = 'iubenda-script'
    scriptTag.type = "text/javascript";
    scriptTag.src = "//cdn.iubenda.com/cs/iubenda_cs.js"
    var head = document.getElementsByTagName('head')[0];


    head.appendChild(scriptTag);

  })
  return (
    <>
      <Helmet />
      <Header />
      {toast && <Toast {...toast} />}
      {/* <Alert
        name="op_san"
        title="Sei un operatore sanitario?"
        body="Questo sito è destinato esclusivamente a operatori professionali e riporta dati, prodotti e beni sensibili per la salute e la sicurezza del paziente. Pertanto, per visitare il sito, dichiaro di essere un operatore sanitario."
        button="Confermo" /> */}
      <main id="main" className={name}>
        {children}
      </main>
      <Footer />
    </>
  )
}

export default Layout
